module.exports = __webpack_public_path__ + "./img/logoParadigma.223321004a934af77802d9ba50a96c06.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/logoParadigma.png
// module id = ./public/img/logoParadigma.png
// module chunks = 0